import { render } from "./Items.vue?vue&type=template&id=d228e704"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Product/Items.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d228e704"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d228e704', __exports__)) {
    api.reload('d228e704', __exports__)
  }
  
  module.hot.accept("./Items.vue?vue&type=template&id=d228e704", () => {
    api.rerender('d228e704', render)
  })

}


export default __exports__